<template>
    <div>
        <button class="iconfont icon-wxbsousuotuiguang" @click='goSearch'>搜索一下</button>
    </div>
</template>

<script>
export default {
    data() {
        return {

        };
    },
    methods: {
        goSearch(){
            console.log('搜索中。。。');
        }
    },
};
</script>

<style  scoped>

</style>
